<template>
  <div>
    <el-drawer :visible.sync="goOpen"
               append-to-body
               destroy-on-close
               :size="sizeHcalced"
               :title="title"
               class="myModal"
               position="top"
               :show-close="!$slots.header"
               direction="ttb" :style="optimalStyle">
      <el-row slot="title" v-if="!!$slots.header">

        <slot name="header"></slot>

      </el-row>
      <div ref="slotBody">

        <slot v-if="displaySlot"></slot>

      </div>
      <el-row>

        <slot name="footer"></slot>

      </el-row>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "SModal",
  data() {
    return {
      displaySlot: false,
      goOpen: false
    }
  },
  props: {
    sizeH: {default: '60%'},
    sizeW: {default: 70, type: Number},
    title: {
      type: String, default: null
    },
    value: {
      type: Boolean, default: false
    }
  },
  watch: {
    goOpen(v, vo) {
      if (v !== vo && v !== this.value)
        this.$emit('input', v)
      if (!v)
        this.$emit('close', v)
      else this.$nextTick(() => {
        this.displaySlot = true
      })
    },
    value(v, vo) {
      if (v !== vo)
        this.goOpen = v
    }
  },
  mounted() {
    this.$nextTick(() => {

    })
  },
  computed: {
    sizeHcalced() {
      return this.isWindowSize('md', true) ? this.sizeH : '100%'
    },
    // goOpen: {
    //   get() {
    //     return this.value
    //   },
    //   set(v) {
    //     this.$emit('update', v)
    //   }
    // },
    optimalStyle() {
      // _log_('this.isWindowSize(  ', this.isWindowSize('md', true))
      return this.isWindowSize('md', true) ?
          {width: this.sizeW + 'vw', marginLeft: ((100 - this.sizeW) / 2) + 'vw'} :
          {width: '100vw'}
    }
  }
}
</script>

<style>
.myModal .el-drawer__body {
  padding: 1.3em;
}

.myModal .el-drawer.ttb {
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;
}

.myModal .el-drawer.ttb .el-drawer__body {
  padding: 1.2em;
}
</style>